export default __webpack_public_path__ + "static/media/ux-analytic-logo-white.63704010.svg";